import RESTClient from 'web-app/api/clients/rest-client-famly-app';

import type * as Models from './models';

export const createEmployeeContact = (employeeId: string, data: Models.FormData) =>
    RESTClient.postAuthenticatedObservable('v2/employeerelations', {
        employeeId,
        email: '',
        homePhone: '',
        workPhone: '',
        ...data,
    });
